import { render, staticRenderFns } from "./perception-detail.vue?vue&type=template&id=59b20cf8&"
import script from "./perception-detail.vue?vue&type=script&lang=ts&"
export * from "./perception-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports